// MARK://dhk8/pos/lib/queries/orders
// Queries tipadas de órdenes — F4.1 / ADR-0009. El POS lee las órdenes por el grafo
// (pos-orders, tenant del JWT). Escrituras (crear/fire/pagar/cancelar/mover/items/
// sub-cuentas) siguen REST. Cada query selecciona TODOS los campos de BackendOrderDto
// (items+modifiers+subAccounts) para que el cast en orders.ts sea fiel. Los campos van
// inline en cada query (el preset `client` de codegen NO evalúa interpolaciones en el
// tag `graphql`).
import { graphql } from '../../gql/index.js'

export const PosOrdersQuery = graphql(`
  query PosOrders($branchId: String, $status: String, $from: String, $to: String, $page: Int, $limit: Int) {
    orders(branchId: $branchId, status: $status, from: $from, to: $to, page: $page, limit: $limit) {
      total
      page
      limit
      items {
        id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
        openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
        totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
        items {
          id orderId subAccountId productId variantId variantName comboId name
          quantity unitPriceCents discountCents taxRate taxCents totalCents status
          kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
          modifiers { id orderItemId modifierId name priceDeltaCents }
        }
        subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
      }
    }
  }
`);

export const PosOrderQuery = graphql(`
  query PosOrder($id: ID!) {
    order(id: $id) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosOrderOpenByTableSessionQuery = graphql(`
  query PosOrderOpenByTableSession($tableSessionId: ID!) {
    orderOpenByTableSession(tableSessionId: $tableSessionId) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosOrderPaymentsQuery = graphql(`
  query PosOrderPayments($orderId: ID!) {
    orderPayments(orderId: $orderId) {
      id orderId subAccountId method amountCents tipCents changeCents
      cardLastFour reference status refundedCents capturedById capturedAt refundedAt
    }
  }
`);

export const PosRecordOrderPaymentMutation = graphql(`
  mutation PosRecordOrderPayment($orderId: ID!, $input: RecordOrderPaymentInput!) {
    recordOrderPayment(orderId: $orderId, input: $input) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosCreateOrderMutation = graphql(`
  mutation CreateOrder($input: CreateOrderInput!) {
    createOrder(input: $input) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosAddOrderItemMutation = graphql(`
  mutation AddOrderItem($orderId: ID!, $input: AddOrderItemInput!) {
    addOrderItem(orderId: $orderId, input: $input) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosUpdateOrderItemMutation = graphql(`
  mutation UpdateOrderItem($orderId: ID!, $itemId: ID!, $input: UpdateOrderItemInput!, $managerAuthToken: String) {
    updateOrderItem(orderId: $orderId, itemId: $itemId, input: $input, managerAuthToken: $managerAuthToken) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosRemoveOrderItemMutation = graphql(`
  mutation RemoveOrderItem($orderId: ID!, $itemId: ID!, $managerAuthToken: String) {
    removeOrderItem(orderId: $orderId, itemId: $itemId, managerAuthToken: $managerAuthToken) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosFireOrderMutation = graphql(`
  mutation FireOrder($orderId: ID!) {
    fireOrder(orderId: $orderId) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosApplyOrderDiscountMutation = graphql(`
  mutation ApplyOrderDiscount($orderId: ID!, $input: OrderDiscountInput!) {
    applyOrderDiscount(orderId: $orderId, input: $input) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosSetOrderTipMutation = graphql(`
  mutation SetOrderTip($orderId: ID!, $tipCents: Int!) {
    setOrderTip(orderId: $orderId, tipCents: $tipCents) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosCancelOrderMutation = graphql(`
  mutation CancelOrder($orderId: ID!, $reason: String!, $managerAuthToken: String) {
    cancelOrder(orderId: $orderId, reason: $reason, managerAuthToken: $managerAuthToken) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosReopenOrderMutation = graphql(`
  mutation ReopenOrder($orderId: ID!, $reason: String!, $managerAuthToken: String) {
    reopenOrder(orderId: $orderId, reason: $reason, managerAuthToken: $managerAuthToken) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosCreateOrderSubAccountMutation = graphql(`
  mutation CreateOrderSubAccount($orderId: ID!, $label: String!) {
    createOrderSubAccount(orderId: $orderId, label: $label) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosUpdateOrderSubAccountMutation = graphql(`
  mutation UpdateOrderSubAccount($orderId: ID!, $subAccountId: ID!, $label: String!) {
    updateOrderSubAccount(orderId: $orderId, subAccountId: $subAccountId, label: $label) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

export const PosMoveOrderMutation = graphql(`
  mutation MoveOrder($orderId: ID!, $input: OrderMoveInput!) {
    moveOrder(orderId: $orderId, input: $input) {
      id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
      openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
      totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
      items {
        id orderId subAccountId productId variantId variantName comboId name
        quantity unitPriceCents discountCents taxRate taxCents totalCents status
        kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
        modifiers { id orderItemId modifierId name priceDeltaCents }
      }
      subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
    }
  }
`);

// F9.10 — refund (money-path) por el grafo. Devuelve RefundResult { refund, order }
// (el PosRefund creado + la orden con paidCents ya decrementado). Gateada en el
// resolver por el permiso pos-orders:order:refund@* del JWT (ADR-0019); cuando el
// valor del permiso es 'manager_pin_required', el resolver exige managerPinPasswordHash.
export const PosRefundOrderMutation = graphql(`
  mutation RefundOrder($orderId: ID!, $input: RefundOrderInput!) {
    refundOrder(orderId: $orderId, input: $input) {
      refund {
        id tenantId branchId orderId paymentId amountCents reason authorizedById status cfdiCancelled createdAt
      }
      order {
        id tenantId branchId folio tableSessionId externalOrderId customerId covers type status
        openedByUserId closedByUserId subtotalCents discountCents discountMeta taxCents tipCents
        totalCents paidCents notes openedAt closedAt cancelledAt cancelReason globalInvoiceId publicTicketUuid pickupCode deliveredAt
        items {
          id orderId subAccountId productId variantId variantName comboId name
          quantity unitPriceCents discountCents taxRate taxCents totalCents status
          kitchenStationId sentToKitchenAt readyAt deliveredAt notes parentOrderItemId isComboRoot createdAt roundId
          modifiers { id orderItemId modifierId name priceDeltaCents }
        }
        subAccounts { id orderId label discountCents tipCents notes createdAt closedAt }
        pendingRounds { id number origin createdAt }
      }
    }
  }
`);
